/* unplugin-vue-components disabled */import script from "./PriceBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceBlock.vue?vue&type=script&lang=ts&setup=true"

import "./PriceBlock.vue?vue&type=style&index=0&id=51d6b4ba&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d6b4ba"]])

export default __exports__